import { useEffect, useState } from "react";
import { Receipt } from "@phosphor-icons/react";
import api from "@/lib/api";
import { pts, tzs, fmtDateTime } from "@/lib/format";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

const types = ["all", "purchase", "redemption", "adjustment", "reversal"];
const badge = { purchase: "text-primary", redemption: "text-destructive", adjustment: "text-amber-600", reversal: "text-amber-600" };

export default function BizTransactions() {
  const [list, setList] = useState(null);
  const [type, setType] = useState("all");

  const load = (t) => api.get("/business/transactions", { params: t && t !== "all" ? { type: t } : {} }).then((r) => setList(r.data)).catch(() => setList([]));
  useEffect(() => { load(type); }, [type]);

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="font-display font-bold text-3xl flex items-center gap-2"><Receipt size={26} className="text-primary" /> Transactions</h1>
        <Select value={type} onValueChange={setType}>
          <SelectTrigger data-testid="txn-filter-type" className="w-44 bg-muted/40 border-black/10 rounded-xl"><SelectValue /></SelectTrigger>
          <SelectContent>{types.map((t) => <SelectItem key={t} value={t} className="capitalize">{t}</SelectItem>)}</SelectContent>
        </Select>
      </div>

      <div className="card-surface overflow-x-auto">
        <table className="w-full text-sm min-w-[600px]">
          <thead className="text-muted-foreground text-xs uppercase tracking-wider border-b border-black/8">
            <tr><th className="text-left p-4">Customer</th><th className="text-left p-4">Type</th><th className="text-left p-4">Staff</th><th className="text-right p-4">Amount</th><th className="text-right p-4">Points</th><th className="text-right p-4">Time</th></tr>
          </thead>
          <tbody>
            {!list && <tr><td colSpan={6} className="p-6 text-center text-muted-foreground">Loading…</td></tr>}
            {list && list.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-muted-foreground">No transactions.</td></tr>}
            {list && list.map((t) => (
              <tr key={t.id} data-testid="txn-row" className="border-b border-black/5">
                <td className="p-4">{t.customer_name}</td>
                <td className={`p-4 capitalize font-medium ${badge[t.type] || ""}`}>{t.type}</td>
                <td className="p-4 text-muted-foreground">{t.staff_name}</td>
                <td className="p-4 text-right">{t.purchase_amount ? tzs(t.purchase_amount) : "—"}</td>
                <td className={`p-4 text-right font-mono ${t.type === "redemption" ? "text-destructive" : "text-primary"}`}>{t.type === "redemption" ? `-${pts(t.points_spent)}` : `+${pts(t.points_awarded)}`}</td>
                <td className="p-4 text-right text-muted-foreground text-xs">{fmtDateTime(t.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
